module.exports = "<app-bulk-assign-form (onLoaded)=\"onLoaded()\"></app-bulk-assign-form>\n<app-sheets-assign [initReload]=\"initReload\"></app-sheets-assign>"